import PanoramicMobx from './panoramic';
import HouseMobx from './house';
import TrafficMobx from './traffic';
import FooterMobx from './footer';
import HeaderMobx from './header';  
import CopyrightMobx from './copyright';
import SellMobx from './sell';
import PanoramaMobx from './components/panorama';

export const PanoramicStore = new PanoramicMobx();
export const HouseStore = new HouseMobx();
export const TrafficStore = new TrafficMobx();
export const FooterStore = new FooterMobx();
export const HeaderStore = new HeaderMobx();
export const CopyrightStore = new CopyrightMobx();
export const SellStore = new SellMobx();
export const PanoramaStore = new PanoramaMobx();


